import React from 'react'
import { ReactNode } from 'react'

interface CardTitleProps {
  children: ReactNode
  className?: string
}

const CardTitle: React.FC<CardTitleProps> = ({ children, className }) => {
  if (!children) return null
  return <h2 className={className}>{children}</h2>
}

export default CardTitle
